import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ButtonComponent} from './button.component';
import {LoadingModule} from '../../../../components/common/loading/loading.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TablerIconsModule} from "angular-tabler-icons";
import {MatBadgeModule} from "@angular/material/badge";
import {IconsModule} from "../../../../../icons.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        LoadingModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule,
        TablerIconsModule,
        MatBadgeModule,
    ],
    declarations: [
        ButtonComponent
    ],
    exports: [
        ButtonComponent
    ],
})
export class ButtonModule {}
